module.exports = __webpack_public_path__ + "img/mic.6c267331.svg";